/* eslint no-shadow: ["error", { "allow": ["state"] }]	*/
import Vue from 'vue';
import Vuex from 'vuex';
import VueSession from 'vue-session';

import eventHub from '../../utils/eventhub';
import {
	registerUser,
	loginUser,
	resetPassword,
	changePassword
} from '../../utils/api/auth';
import {
	success,
	fail
} from '../../utils/toast';

const options = {
	persist: true
};

Vue.use(Vuex);
Vue.use(VueSession, options);

const state = {
	isSession: false,
	token: eventHub.$session.get('token'),
	isLoggedIn: !!eventHub.$session.exists() &&
		eventHub.$session.has('id') &&
		eventHub.$session.has('token'),
	loggedUser: {},
	userObject: {},
	isRegistered: false,
	loginError: null,
	error: {},
	status: '',
	errorMessage: ''
};

const mutations = {
	loginSuccess: (state, user) => {
		state.loggedUser = user;
		state.isLoggedIn = true;
	},
	loginError: (state) => {
		state.loginError = true;
		state.loggedUser = {};
		state.userObject = {};
	},
	registerSuccess: (state) => {
		state.isRegistered = true;
	},
	registerError: (state) => {
		state.isRegistered = false;
	},
	logout: (state) => {
		state.loggedUser = {};
		state.isLoggedIn = false;
		state.userObject = {};
	},
	authRequest: (state) => {
		state.status = 'loading';
	},
	authSuccess: (state) => {
		state.status = 'success';
	},
	authError: (state) => {
		state.status = 'error';
	},
	resetAuthStatus: (state) => {
		state.status = '';
	},
	setLoggedUser: (state, user) => {
		state.loggedUser = user;
	},
	setUserObject: (state, data) => {
		state.userObject = data;
	},
	updateUserObject: (state, data) => {
		state.userObject = {
			...state.userObject,
			...data
		};
		eventHub.$session.set('userData', state.userObject);
	},
	errorMessage: (state, data) => {
		state.errorMessage = data;
	},
	reset: (state) => {
		state.isRegistered = false;
		state.errorMessage = '';
	}
};

const getters = {
	getLoggedUser: (state) => {
		return state.loggedUser;
	},
	getStatus: (state) => {
		return state.status;
	},
	isLoggedIn: (state) => {
		return state.isLoggedIn;
	},
	userObject: (state) => {
		return state.userObject;
	},
	getLogError: (state) => {
		return state.loginError;
	},
	getRegistrationStatus: (state) => {
		return state.isRegistered;
	},
	getErrorMessage: (state) => {
		return state.errorMessage;
	}
};


const actions = {
	register: ({
		commit
	}, userData) => {
		commit('authRequest');
		registerUser(userData)
			.then((response) => {
				if (response.status === 201) {
					commit('registerSuccess');
					commit('authSuccess');
					success({
						title: 'Success! Please check your mail to verify.'
					});
				}
			})
			.catch((error) => {
				commit('registerError');
				commit('authError');
				fail({
					title: 'Oops! Something went wrong'
				});
				if (errorCode.includes(error.response.status)) {
					commit('errorMessage', error.response.data.message);
				} else {
					commit('errorMessage', 'There was an issue while registering');
				}
			})
			.finally(() => {
				commit('resetAuthStatus');
			});
	},
	login: ({
		commit
	}, userData) => {
		commit('authRequest');
		loginUser(userData)
			.then((response) => {
				if (response.status === 200 && ('token' in response.data)) {
					const user = response.data.data;
					user.token = response.data.token;
					commit('loginSuccess', user);
					commit('authSuccess');
					success({
						title: 'Login Success! You\'d be redirected shortly'
					});
					return true;
				}
				commit('loginError');
				commit('authError');
				return false;
			})
			.catch((error) => {
				commit('loginError');
				commit('authError');
				fail({
					title: 'Oops! Something went wrong'
				});
				if (errorCode.includes(error.response.status)) {
					commit('errorMessage', error.response.data.message);
				} else {
					commit('errorMessage', 'There was an issue while logging in');
				}
			});
		return true;
	},
	resetPassword: ({
		commit
	}, data) => {
		commit('authRequest');
		resetPassword(data)
			.then((response) => {
				if (response.status === 200) {
					success({
						title: 'Password reset success!'
					});
					commit('authSuccess');
					return true;
				}
				commit('authError');
				return false;
			})
			.catch((error) => {
				commit('authError');
				fail({
					title: 'Oops! Something went wrong, Please try again'
				});

				if (errorCode.includes(error.response.status)) {
					commit('errorMessage', error.response.data.message);
				} else {
					commit('errorMessage', 'There was an issue while registering');
				}
			});
		return true;
	},
	changePassword: ({
		commit
	}, password) => {
		commit('resetAuthStatus');
		commit('authRequest');
		changePassword(password)
			.then((response) => {
				if (response.status === 200) {
					success({
						title: 'Password changed successfully!'
					});
					commit('authSuccess');
					return true;
				}
				fail({
					title: 'Password reset was not success!'
				});
				commit('authError');
				return false;
			})
			.catch(() => {
				commit('authError');
				fail({
					title: 'Oops!',
					text: 'Password reset was not successful'
				});

				if (errorCode.includes(error.response.status)) {
					commit('errorMessage', error.response.data.message);
				} else {
					commit('errorMessage', 'There was an issue while registering');
				}
				return false;
			});
		return true;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};